/**
 * Constants for parent/component item creation feature
 */

// Maximum number of components that can be created in a batch
export const MAX_BATCH_COMPONENTS = 10;

// Maximum total components a parent can have
export const MAX_TOTAL_COMPONENTS = 10;

// ItemType options from question "2"
export const ITEM_TYPE_OPTIONS = [
  { label: "Hardware", value: "Hardware" },
  { label: "Test, Inspection, and Production Equipment", value: "Test, Inspection, and Production Equipment" },
  { label: "Materials", value: "Materials" },
  { label: "Software", value: "Software" },
  { label: "Technology", value: "Technology" }
] as const;

// Type for ItemType values
export type ItemType = typeof ITEM_TYPE_OPTIONS[number]['value'];